/**
 * Single source of truth: Offerten-Status (Workflow).
 */

export const OFFERTE_STATUS = Object.freeze({
  ENTWURF: "Entwurf",
  VERSENDET: "Versendet",
  ZUSCHLAG: "Zuschlag",
  ABGELEHNT: "Abgelehnt",
  ARCHIVIERT: "Archiviert",
});

/** @type {readonly string[]} */
export const OFFERTE_STATUS_VALUES = Object.freeze([
  OFFERTE_STATUS.ENTWURF,
  OFFERTE_STATUS.VERSENDET,
  OFFERTE_STATUS.ZUSCHLAG,
  OFFERTE_STATUS.ABGELEHNT,
  OFFERTE_STATUS.ARCHIVIERT,
]);

/** Nur noch gültige Workflow-Stati (Legacy-Werte entfernt) */
export const OFFERTE_ARCHIVE_ALLOWED_STATUS = Object.freeze(new Set(OFFERTE_STATUS_VALUES));

export const OFFERTE_STATUS_ALIAS_ENTRIES = Object.freeze([
  ["neu", "Entwurf"],
  ["offen", "Entwurf"],
  ["entwurf", "Entwurf"],
  ["versendet", "Versendet"],
  ["versendetet", "Versendet"],
  ["gesendet", "Versendet"],
  ["angenommen", "Zuschlag"],
  ["zuschlag", "Zuschlag"],
  ["verloren", "Abgelehnt"],
  ["abgelehnt", "Abgelehnt"],
  ["archiv", "Archiviert"],
  ["archiviert", "Archiviert"],
]);
